// extracted by css-extract-rspack-plugin
export default {"root":"root-3PL6N","chevron":"chevron-2erlH","popup":"popup-3__Sl"};